import React, { Fragment } from 'react';
import PropTypes, { shape } from 'prop-types';
import { Container, Row } from 'react-bootstrap';
import HeroTextCarousel from '../../HeroImage/HeroTextCarousel';
import "./Hero.scss";

export default function Hero(props) {
  const {heroText, heroImageUrl, heroImageTabletUrl, heroImageMobileUrl, customHeroImageUrls, isAccountLandingOverride } = props;
  
  // Helper to determine image URL based on your logic
  const getUrl = (custom, prop, fallback = '/product-landing/term/term-hero-image.png') => {
    if (isAccountLandingOverride && heroImageUrl) return heroImageUrl;
    return custom || prop || fallback;
  };

  // Pre-calculate the URLs for our CSS variables
  const bgDesktop = getUrl(customHeroImageUrls.heroImageUrl, heroImageUrl);
  const bgTablet = getUrl(customHeroImageUrls.heroImageTabletUrl, heroImageTabletUrl);
  const bgMobile = getUrl(customHeroImageUrls.heroImageMobileUrl, heroImageMobileUrl, '/product-landing/term/term-hero-mobile.png');

  const heroBridge = {
  '--hero-bg-mobile': `url(${bgMobile})`,
  '--hero-bg-tablet': `url(${bgTablet})`,
  '--hero-bg-desktop': `url(${bgDesktop})`,
  };
  
  const removeBreak = (text) => {
    return text.replace("<br>", " ");
  }

  return (
    <Fragment>
      <Row className="hero-wrapper v3_1_1">
        <header className={`hero-container hero-bg-image`} style={heroBridge}>
          <Container>
            <div className="hero-grid">
              <div className="value-prop-container">
                <div className="value-prop">
                  {heroText.custom && <HeroTextCarousel carouselItems={heroText.custom} cycleTime={3500} />}
                  {!heroText.custom &&
                  <Fragment>
                    { heroText.default.title && <h3 dangerouslySetInnerHTML={{ __html: heroText.default.title }}></h3> }
                    { heroText.default.subtitle && <h2 dangerouslySetInnerHTML={{__html: removeBreak(heroText.default.subtitle)}}></h2> }
                    { heroText.default.subtitleExtended && <p dangerouslySetInnerHTML={{__html: removeBreak(heroText.default.subtitleExtended)}}></p> }
                  </Fragment>}
                </div>
              </div>
            </div>
          </Container>
        </header>
      </Row>
    </Fragment>
  );
}

Hero.propTypes = {
  customHeroImageUrls: PropTypes.objectOf(shape({
    heroImageMobileUrl: PropTypes.string,
    heroImageTabletUrl: PropTypes.string,
    heroImageUrl: PropTypes.string,
  })),
  heroImageMobileUrl: PropTypes.string,
  heroImageTabletUrl: PropTypes.string,
  heroImageUrl: PropTypes.string,
  heroText: PropTypes.objectOf(shape({
    custom: PropTypes.string,
    default: PropTypes.objectOf(shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      subtitleExtended: PropTypes.string.isRequired,
    })),
  })),
};
